const NORMALIZED_VAT_PATTERN = /^(?:\d{11}|[A-Z]{2}[A-Z0-9]{2,14})$/;

export const VAT_INPUT_PATTERN = /^(?:\d{11}|[A-Z]{2}\s?[A-Z0-9.\-/]{2,14})$/i;

export const DEFAULT_VAT_COUNTRY = "IT";

export function normalizeVatNumber(value) {
  if (value == null) {
    return "";
  }
  return String(value).trim().toUpperCase().replace(/[\s./-]+/g, "");
}

export function isValidVatNumber(value) {
  const normalized = normalizeVatNumber(value);
  if (!normalized) {
    return false;
  }
  return NORMALIZED_VAT_PATTERN.test(normalized);
}

export function buildVatNumber(countryCode, body) {
  const normalizedBody = normalizeVatNumber(body);
  if (!normalizedBody) {
    return "";
  }

  if (NORMALIZED_VAT_PATTERN.test(normalizedBody)) {
    return normalizedBody;
  }

  const cc = normalizeVatNumber(countryCode).slice(0, 2);
  if (cc.length === 2) {
    return cc + normalizedBody;
  }

  return normalizedBody;
}

export function parseVatFields(value) {
  const normalized = normalizeVatNumber(value);
  if (!normalized) {
    return { countryCode: DEFAULT_VAT_COUNTRY, body: "" };
  }
  if (/^\d{11}$/.test(normalized)) {
    return { countryCode: DEFAULT_VAT_COUNTRY, body: normalized };
  }
  const match = normalized.match(/^([A-Z]{2})([A-Z0-9]{2,14})$/);
  if (match) {
    return { countryCode: match[1], body: match[2] };
  }
  return { countryCode: DEFAULT_VAT_COUNTRY, body: normalized.slice(0, 14) };
}
